import { useSelector } from 'react-redux';

const useLoggedStatus = () => {
  const token = useSelector((state) => state.auth.token);
  const tokenLocal = localStorage.getItem('token');
  const collaboratorlocalId = localStorage.getItem('collaborator_id');
  const collaborator = useSelector(
    (state) => state.collaborator.collaboratorInfo.collaborator_id
  );

  const hasToken = Boolean(token || tokenLocal);
  const ownsProfile =
    Boolean(collaboratorlocalId) &&
    Boolean(collaborator) &&
    String(collaborator) === String(collaboratorlocalId);

  return hasToken && ownsProfile;
};

export default useLoggedStatus;
